import { c as _c } from "react/compiler-runtime";
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
const createDTO = coupon => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    boards,
    week,
    ...couponRest
  } = coupon;
  // Returns stable reference using Zustand useShallow
  return {
    ...couponRest,
    drawCount: week
  };
};
/**
 * Gets the view model representation of a given coupon.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @returns Coupon model without boards
 */
export function useCoupon(t0) {
  const $ = _c(3);
  const {
    couponId,
    couponIndex
  } = t0;
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex,
      selector: _temp
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const coupon_0 = useSubscribedCoupon(t1);
  return coupon_0;
}
function _temp(coupon) {
  if (!coupon) {
    return;
  }
  return createDTO(coupon);
}